import { cva } from 'class-variance-authority';
import type { Size } from './types';

const sizeVariants = {
  large: 'h-[32px] w-[56px]',
  medium: 'h-[24px] w-[42px]',
  small: 'h-[20px] w-[35px]',
  byBreakpoint: 'h-[24px] w-[42px] lg:h-[32px] lg:w-[56px]',
} satisfies Record<Size, string>;

export const icon = cva('inline-flex', {
  variants: {
    size: sizeVariants,
    color: {
      darkgreen: 'text-color-efficiency-darkgreen',
      mediumgreen: 'text-color-efficiency-mediumgreen',
      lightgreen: 'text-color-efficiency-lightgreen',
      yellow: 'text-color-efficiency-yellow',
      lightorange: 'text-color-efficiency-lightorange',
      darkorange: 'text-color-efficiency-darkorange',
      red: 'text-color-efficiency-red',
    },
  },
});
